import { Factory, association, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { format } from 'date-fns';

export default Factory.extend({
  expired: false,
  approvalStatus() {
    return faker.helpers.arrayElement(['review', 'approved', 'denied']);
  },
  userDocument: association(),
  location: association(),

  asApproved: trait({
    afterCreate(userDocumentLocationContext) {
      userDocumentLocationContext.update({ approvalStatus: 'approved' });
    },
  }),

  asDenied: trait({
    afterCreate(userDocumentLocationContext) {
      userDocumentLocationContext.update({ approvalStatus: 'denied' });
    },
  }),

  asReview: trait({
    afterCreate(userDocumentLocationContext) {
      userDocumentLocationContext.update({ approvalStatus: 'review' });
    },
  }),

  asWillExpire: trait({
    expirationDate: () => format(faker.date.future(), 'yyyy-MM-dd'),
    expired: false,
  }),

  asExpired: trait({
    expirationDate: () => format(faker.date.future(), 'yyyy-MM-dd'),
    expired: true,
  }),

  asExpiring: trait({
    expirationDate: () => format(new Date(), 'yyyy-MM-dd'),
    expired: false,
  }),
});
